var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_vm._l(_vm.itemsToShow, function (src, index) {
    return _c('v-col', {
      key: index
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "tile": "",
        "outlined": ""
      },
      on: {
        "!click": function click($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showDialogWith(index);
        }
      }
    }, [_c('v-img', _vm._b({}, 'v-img', {
      src: src,
      aspectRatio: 1 / 1
    }, false))], 1)], 1);
  }), _vm.items.length >= _vm.displaylength ? _c('v-col', [_c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "outlined": ""
    },
    on: {
      "!click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.showDialogWith(_vm.displaylength - 1);
      }
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1 / 1,
      "src": _vm.items[this.displaylength - 1]
    }
  }, [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "z-index": "0"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-magnify-plus-outline")])], 1)], 1)], 1)], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "max-width": "740",
      "overlay-opacity": ".7"
    },
    model: {
      value: _vm.showsDialog,
      callback: function callback($$v) {
        _vm.showsDialog = $$v;
      },
      expression: "showsDialog"
    }
  }, [_c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showsCloseBtn,
      expression: "showsCloseBtn"
    }],
    staticClass: "v-dialog__close",
    attrs: {
      "tile": "",
      "color": "#1e1e1e"
    },
    on: {
      "click": function click($event) {
        _vm.showsDialog = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "size": "30"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    class: "rental-banner rental-banner-".concat(_vm.random)
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.items, function (src, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('v-card', {
      staticClass: "overflow-hidden",
      attrs: {
        "tile": "",
        "flat": "",
        "color": "#1e1e1e"
      }
    }, [_c('v-img', _vm._b({
      attrs: {
        "contain": ""
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function fn() {
          return [_c('v-overlay', {
            attrs: {
              "absolute": "",
              "z-index": "0",
              "opacity": ".1"
            }
          }, [_c('v-icon', [_vm._v("mdi-image-off")])], 1)];
        },
        proxy: true
      }], null, true)
    }, 'v-img', {
      src: src,
      maxHeight: '60vh',
      aspectRatio: 1 / 1
    }, false))], 1)], 1);
  }), 0)]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-prev"
  }, [_c('i', {
    staticClass: "icon icon-chevron-left-white"
  })]), _c('div', {
    staticClass: "swiper-next"
  }, [_c('i', {
    staticClass: "icon icon-chevron-right-white"
  })])])]), _c('div', {
    staticClass: "mt-20 mt-md-30"
  }, [_c('div', {
    class: "rental-banner-thumb rental-banner-thumb-".concat(_vm.random),
    attrs: {
      "thumbsSlider": ""
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.items, function (src, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('v-card', {
      staticClass: "overflow-hidden",
      attrs: {
        "tile": "",
        "flat": "",
        "color": "#1e1e1e"
      }
    }, [_c('v-img', _vm._b({
      attrs: {
        "contain": ""
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function fn() {
          return [_c('v-overlay', {
            attrs: {
              "absolute": "",
              "z-index": "0",
              "opacity": ".1"
            }
          }, [_c('v-icon', [_vm._v("mdi-image-off")])], 1)];
        },
        proxy: true
      }], null, true)
    }, 'v-img', {
      src: src,
      maxHeight: '20vh',
      aspectRatio: 1 / 1
    }, false))], 1)], 1);
  }), 0)])])])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }